module.exports = OneAppDucks;